import { render, staticRenderFns } from "./TutorialCard.vue?vue&type=template&id=510d633e&scoped=true&"
import script from "./TutorialCard.vue?vue&type=script&lang=js&"
export * from "./TutorialCard.vue?vue&type=script&lang=js&"
import style0 from "./TutorialCard.vue?vue&type=style&index=0&id=510d633e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510d633e",
  null
  
)

export default component.exports